import { call, put, select, takeLatest } from "redux-saga/effects";
import { FETCH_EVENTS_REQUEST, fetchEventsFailure, fetchEventsSuccess } from "../actions/eventsActions";
import { fetchEventsData } from "../../../services/commonService";

// Worker Saga
function* fetchEventsSaga() {
  try {
    const params = yield select(state=>state?.eventsReducer?.payload);
    const data = yield call(fetchEventsData,params);

    yield put(fetchEventsSuccess(data));
  } catch (error) {
    yield put(fetchEventsFailure(error.message));
  }
}

// Watcher Saga
export function* watchFetchEvents() {
  yield takeLatest(FETCH_EVENTS_REQUEST, fetchEventsSaga);
}
